import { RequestHeader } from '@app/@utlity/model/request/request-header';
import { CustomerLogInRequestBody } from './customer-log-in-request-body';
import { CustomerLogInRequestHeader } from './customer-log-in-request-header';

export class CustomerLogInRequest {
  header: RequestHeader;
  body: CustomerLogInRequestBody;
}
